import { debounce } from "lodash";
import { APIClient } from "../../../helpers/api_helper";
import {
  UI_PREFS_CACHE_KEY,
  recieveUiPrefs,
  setIntentsColumnPrefsLocal,
} from "./reducer";

const api = new APIClient();
const URL = "/api/users/me/preferences/";

const cache = (prefs) => {
  try {
    localStorage.setItem(UI_PREFS_CACHE_KEY, JSON.stringify(prefs || {}));
  } catch (e) {
    /* private mode / quota -- the server copy is still authoritative */
  }
};

export const loadUiPrefs = () => async (dispatch) => {
  try {
    const data = await api.get(URL);
    cache(data || {});
    dispatch(recieveUiPrefs(data || {}));
  } catch (error) {
    console.error("Unable to load user preferences!", error);
  }
};

// successMsg: null is required -- APIClient.update always sets `meta`, and the
// response interceptor toasts "Uspešno shranjeno!" whenever it is present. Without
// it every arrow click would raise a notification.
const persist = debounce((intents_columns) => {
  api
    .update(URL, { intents_columns }, { successMsg: null })
    .then((data) => cache(data || {}))
    .catch((error) => console.error("Preferences save failed", error));
}, 800);

export const setIntentsColumnPrefs = (next) => async (dispatch) => {
  dispatch(setIntentsColumnPrefsLocal(next));
  persist(next);
};

// Five of the six tables live inside an expandable row: collapsing it unmounts
// the component, so there is no reliable "done" moment. Flush on unmount instead.
export const flushUiPrefs = () => async () => persist.flush();
